import { useEffect, useState } from 'react';
import { tr } from '@repo/locale';
import { formatCountdownTime } from '@repo/date-time';

interface Params {
  initialSeconds: number;
  onExpire?: () => void;
}

interface Return {
  formattedTime: string;
}

const TIMER_TICK_MS = 1000;

export function useCountdownTimer({ initialSeconds, onExpire }: Params): Return {
  const clampedInitialSeconds = Math.max(0, initialSeconds);
  const [timeLeft, setTimeLeft] = useState<number>(clampedInitialSeconds);
  const [isExpired, setIsExpired] = useState<boolean>(false);

  useEffect(() => {
    if (clampedInitialSeconds <= 0) return;

    const timer = setInterval(() => {
      setTimeLeft((currentTime) => {
        if (currentTime <= 1) {
          clearInterval(timer);
          setIsExpired(true);
          return 0;
        }
        return currentTime - 1;
      });
    }, TIMER_TICK_MS);

    return () => clearInterval(timer);
  }, [clampedInitialSeconds]);

  useEffect(() => {
    if (isExpired && onExpire) {
      onExpire();
    }
  }, [isExpired, onExpire]);

  const minuteLabel = tr('time.minute_shortcut');
  const secondLabel = tr('time.second_shortcut');

  return {
    formattedTime: formatCountdownTime(timeLeft, minuteLabel, secondLabel),
  };
}
